module.exports = {"469007100":"八所镇","469007101":"东河镇","469007102":"大田镇","469007103":"感城镇","469007104":"板桥镇","469007105":"三家镇","469007106":"四更镇","469007107":"新龙镇","469007200":"天安乡","469007201":"江边乡","469007500":"东方华侨农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469007.json
// module id = 2201
// module chunks = 0